import * as Sentry from '@sentry/browser';
import axios from 'axios';
class Upload {
    axiosInstance;
    static auth;
    static config;
    constructor(auth, axiosInstance, config) {
        this.axiosInstance = axiosInstance;
        Upload.auth = auth;
        Upload.config = config;
    }
    headers() {
        return {
            Authorization: `Bearer ${Upload.auth.currentToken}`,
        };
    }
    //     upload: import.meta.env.VITE_BASE_API_URL + '/image/wayste/upload',
    //     uploadPublicLogo: import.meta.env.VITE_BASE_API_URL + '/image/wayste/upload/logo',
    //     delete: import.meta.env.VITE_BASE_API_URL + '/image/wayste/delete',
    wayste = {
        image: {
            /**
             * Fetches an image from S3
             * @param id key of the image
             * @returns image url
             */
            fetch: async (id, bucket) => {
                try {
                    const res = await this.axiosInstance.mainInstance.post(`${Upload.config.API.baseApiUrl}/image/wayste/fetch`, {
                        path: id,
                        bucket: bucket,
                    });
                    return res.data;
                }
                catch (error) {
                    Sentry.captureException(error);
                    throw error;
                }
            },
            /**
             * Uploads an image to S3
             * @param key key of the image
             * @param file File to be uploaded
             * @returns bucket, key, and region needed to make S3ItemReference
             */
            upload: async (key, file) => {
                try {
                    const formData = new FormData();
                    formData.append('path', key);
                    formData.append('file', file);
                    const res = await axios.post(`${Upload.config.API.baseApiUrl}/image/wayste/upload`, formData, {
                        headers: { ...this.headers(), 'Content-Type': 'multipart/form-data' },
                    });
                    return { bucket: String(res.data.Bucket), key: String(res.data.Key), region: 'us-east-1' };
                }
                catch (error) {
                    Sentry.captureException(error);
                    throw error;
                }
            },
            /**
             * Delete a file from S3 bucket Directly
             * @param file - File object to be uploaded
             * @param key - S3 key
             */
            delete: async (file) => {
                try {
                    const response = await this.axiosInstance.mainInstance.delete(`${Upload.config.API.baseApiUrl}/image/wayste/delete`, {
                        data: {
                            path: file,
                        },
                    });
                    return response.data;
                }
                catch (error) {
                    Sentry.captureException(error);
                    throw error;
                }
            },
        },
    };
    adminPortal = {
        image: {
            /**
             * fetches a file from S3
             * @param path
             * @returns
             */
            fetch: async (path, bucket) => {
                try {
                    const response = await axios({
                        method: 'POST',
                        url: `${Upload.config.API.baseApiUrl}/image/admin-portal/fetch`,
                        headers: this.headers(),
                        data: {
                            path: path,
                            bucket: bucket,
                        },
                    });
                    return response.data;
                }
                catch (error) {
                    Sentry.captureException(error);
                    throw error;
                }
            },
            /**
             * fetches all files from a folder from S3
             * @param folderName
             * @param images - Array of S3ItemReference
             * @returns
             */
            fetchAll: async (folderName, images) => {
                try {
                    const response = await axios({
                        method: 'POST',
                        url: `${Upload.config.API.baseApiUrl}/image/admin-portal/fetch-all`,
                        headers: this.headers(),
                        data: {
                            path: folderName,
                            images: images,
                        },
                    });
                    return response.data;
                }
                catch (error) {
                    Sentry.captureException(error);
                    throw error;
                }
            },
            /**
             * Uploads a file to S3
             * @param key key of the image
             * @param file File to be uploaded
             * @returns bucket, key, and region needed to make S3ItemReference
             * @returns
             */
            upload: async (key, file) => {
                const formData = new FormData();
                formData.append('path', key);
                formData.append('file', file);
                try {
                    const res = await axios({
                        method: 'POST',
                        url: `${Upload.config.API.baseApiUrl}/image/admin-portal/upload`,
                        headers: {
                            ...this.headers(),
                            'Content-Type': 'multipart/form-data',
                        },
                        data: formData,
                    });
                    return { bucket: String(res.data.Bucket), key: String(res.data.Key), region: 'us-east-1' };
                }
                catch (error) {
                    Sentry.captureException(error);
                    throw error;
                }
            },
            /**
             * Delete a file from S3 bucket Directly
             * @param file - File object to be uploaded
             * @param key - S3 key
             */
            delete: async (file) => {
                try {
                    const response = await axios({
                        method: 'DELETE',
                        url: `${Upload.config.API.baseApiUrl}/image/admin-portal/delete`,
                        headers: this.headers(),
                        data: {
                            path: file,
                        },
                    });
                    return response.data;
                }
                catch (error) {
                    Sentry.captureException(error);
                    throw error;
                }
            },
        },
    };
    customerPortal = {
        image: {
            upload: async (key, file) => {
                const formData = new FormData();
                formData.append('path', key);
                formData.append('file', file);
                try {
                    const res = await axios({
                        method: 'POST',
                        url: `${Upload.config.API.baseApiUrl}/image/sourgum-customer-portal/upload`,
                        headers: {
                            ...this.headers(),
                            'Content-Type': 'multipart/form-data',
                        },
                        data: formData,
                    });
                    return { bucket: String(res.data.Bucket), key: String(res.data.Key), region: 'us-east-1' };
                }
                catch (error) {
                    Sentry.captureException(error);
                    throw error;
                }
            },
        },
    };
    waysteDashboard = {
        image: {
            /**
             * Fetches an image from S3
             * @param id key of the image
             * @returns image url
             */
            fetch: async (id, bucket) => {
                try {
                    const res = await this.axiosInstance.mainInstance.post(`${Upload.config.API.baseApiUrl}/image/wayste-dashboard/fetch`, {
                        path: id,
                        bucket: bucket,
                    });
                    return res.data;
                }
                catch (error) {
                    Sentry.captureException(error);
                    throw error;
                }
            },
            signDocument: async (key, agreementS3ItemRef, signatureFile, signedName) => {
                const formData = new FormData();
                formData.append('signaturePath', key);
                formData.append('agreementReference', JSON.stringify(agreementS3ItemRef));
                formData.append('file', signatureFile);
                formData.append('signedName', signedName);
                try {
                    const res = await this.axiosInstance.mainInstance.post(`${Upload.config.API.baseApiUrl}/image/wayste-dashboard/sign-document`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
                    return { bucket: String(res.data.Bucket), key: String(res.data.Key), region: 'us-east-1' };
                }
                catch (error) {
                    Sentry.captureException(error);
                    throw error;
                }
            },
        },
    };
}
export default Upload;
//# sourceMappingURL=Upload.service.js.map